export default "__VITE_ASSET__BMCfUFWJ__"